import React, { useEffect } from 'react';
import { Field } from 'formik'
import { FormikSelectComponent } from '../../../utilities/formUtils'


const DateTypeOptions = ({ name, isTxn, isLabel, label, isSelection, setOnSelect, placeholder, userProps, width, getvalue: callback, index, type, setFieldValue, values }, props) => {

    const getSelectedValue = (values) => {
        // console.log("Vtype Selected", values)
    }


    const options = [
        { key: 1, text: 'Created Date', value: 'created_date' },
        { key: 2, text: 'Trans Date', value: 'TRANS_DATE' },
    ]

    useEffect(() => {
        setFieldValue('datetype', 'created_date')
    }, [])


    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} label={label} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, getValue: getSelectedValue, index, placeholder }} placeholder={placeholder} width={width}> </Field>
    )

}


export default DateTypeOptions;